"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.setupVerificationEndpoints = void 0;
var utils_1 = require("../utils");
var getBasePath = (0, utils_1.getBasePathFactory)('/verification');
function setupVerificationEndpoints(api) {
    return api.injectEndpoints({
        endpoints: function (build) { return ({
            startVerification: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, verificationId = _a.verificationId, body = __rest(_a, ["customerId", "verificationId"]);
                    return ({
                        url: "".concat(getBasePath(customerId), "/").concat(verificationId, "/start-verification"),
                        method: 'POST',
                        body: body
                    });
                }
            }),
            selfReportIncome: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, verificationId = _a.verificationId, body = __rest(_a, ["customerId", "verificationId"]);
                    return ({
                        url: "".concat(getBasePath(customerId), "/").concat(verificationId, "/self-report-income"),
                        method: 'POST',
                        body: body
                    });
                }
            })
        }); }
    });
}
exports.setupVerificationEndpoints = setupVerificationEndpoints;
